 <!-- coperbizitravelonlineaktarim.vue -->

<template>
  <div>
    <baseaktarim
      :logo="null"
      :title="this.$t('Bizi-Travel-Hotel-Transfer')"
      v-model="items"
      v-on:aktar="Aktar"
      :status="status"
      :tarihfield="true"
      :menuitems="menuItems"
      v-on:menuclick="menuClick"
    >
    <template slot="toolbar">
      <v-flex xs12 sm6 md2>

        <v-text-field
                hide-details
                label="Customer Id"
                v-model="customerId"
              >
              </v-text-field >

                </v-flex>

      <!-- Acikken "bu kayit zaten yapilmis" kontrolu atlanir; ayni misafir
           icin mukerrer rezervasyon olusabilir. Bilerek varsayilan kapali.
           v-model ile @change BIRLIKTE: v-model kutuyu isaretler, @change
           uyariyi acar ve onaylanmazsa isareti geri alir. Bkz. handler. -->
      <v-flex xs12 sm6 md3>
        <v-checkbox
          hide-details
          v-model="misafirIsmiKontrolEdilmesin"
          :label="$t('Do-Not-Check-Guest-Name')"
          @change="misafirIsmiKontrolDegisti"
        ></v-checkbox>
      </v-flex>

      <!-- "Rezervasyonlari Aktar" butonu bu slot'un DISINDA, coperbaseaktarim.vue
           icinde uretiliyor ve slot'tan SONRA render ediliyor; dokuman
           sirasinda buton bu metinden sonra gelirdi. Bilet aktarim sayfasindaki
           gibi buton metnin solunda kalsin diye order ile bu flex, ayni flex
           container'daki (v-layout) buton flex'inin arkasina itiliyor. Paylasilan
           bilesene dokunulmadi; diger Coper aktarim sayfalarini etkilemez. -->
      <!-- ml-auto: flex satirindaki kalan bosluk bu ogeden ONCE birikir,
           yani flex satirin en sagina yapisir. justify-end ise flex'in
           kendi genisligi buyudugunde (ornegin dar ekranda md12 oldugunda)
           metnin yine sag kenara yasli kalmasini garantiler. -->
      <v-flex xs12 sm12 md3 class="ml-auto" style="order: 100">
        <v-layout align-center justify-end fill-height>
          <a href="#" @click.prevent="$refs.bilgidialog.open()">
            {{ $t('Cari-Kod-Gelmiyor-Ne-Yapmaliyim') }}
          </a>
        </v-layout>
      </v-flex>

    </template>

    </baseaktarim>

    <!-- Misafir ismi kontrolu kapatilirken uyari icin. onaydialog DEGIL confirm:
         options.message verildiginde bir onay kutusu gosteriyor ve "Evet" yalnizca
         kutu isaretliyse calisiyor; kullanicinin riski kabul etmesi zorunlu olur. -->
    <confirm ref="confirm"></confirm>

    <bilgidialog
      ref="bilgidialog"
      :baslik="$t('Cari-Kod-Gelmiyor-Ne-Yapmaliyim')"
      :mesaj="cariKodYardimMesaji"
      :resimSrc="cariKodYardimResim"
    ></bilgidialog>

    <v-dialog
      v-model="dialogayarlar"
      scrollable=""
      persistent=""
      max-width="400px"
    >
      <v-card color="grey lighten-5">
        <v-card-title> Parametreler </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="report_url"
                v-model="BokingAgoraAyar.report_url"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="api_client_key"
                v-model="BokingAgoraAyar.api_client_key"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="api_client_secret"
                v-model="BokingAgoraAyar.api_client_secret"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="api_client_organization_id"
                v-model="BokingAgoraAyar.api_client_organization_id"
              >
              </v-text-field>
            </v-flex>
           
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="dialogayarlar = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="ayarkaydet()">{{
            $t("save_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import baseaktarim from "../aktarim/coperbaseaktarim";
import confirm from "@/components/app/coper/comp/confirm.vue";
import bilgidialog from "@/components/app/customcomp/bilgidialog.vue";
// Bilet tarafindaki BiziClick aktarim sayfasiyla (aktarimbilet/bizitravelonlineaktarim.vue)
// AYNI gorsel ve metin kullanilir; Cari Kod eslestirmesinin ayarlandigi yer
// (BiziClick portali) her iki aktarim icin de ortak.
import cariKodYardimResim from "@/assets/help/BiziClickPortal.png";
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
      dialogayarlar: false,
      customerId:'',
      // Aktarimda "bu kayit zaten yapilmis" kontrolunu atlar. Mukerrer kayit
      // olusturabildigi icin varsayilan kapali.
      misafirIsmiKontrolEdilmesin: false,

      // BiziClick'in kendi metni gelene kadar bilgilendirme icin gecici
      // yer tutucu; kolay bulunup degistirilsin diye i18n sozlugune
      // eklenmedi, dogrudan burada tutuluyor.
      cariKodYardimMesaji:
        "İlgili alana gelmesi gereken değeri BiziClick portalınızda firmayı seçtikten sonra Organizasyon/Firma Bilgileri/Adresler kısımdan tanımlayabilirsiniz.",
      cariKodYardimResim: cariKodYardimResim,

       BokingAgoraAyar: {
        report_url: null,
        api_client_key: null,
        api_client_secret: null,
        api_client_organization_id: null,
        },
      menuItems: [
        {
          title: this.$t('Parameters'),
        },
      ],
    };
  },

  components: {
    baseaktarim,
    confirm,
    bilgidialog,
  },
  methods: {
     ParametreOku: ParametreOku,

    // Kutu ISARETLENIRKEN uyari gosterilir; onaylanmazsa isaret geri alinir.
    // Isareti KALDIRMAK icin onay sorulmaz: o yon zaten guvenli tarafa
    // (kontrol acik) donuyor.
    //
    // Isaret v-model tarafindan ONCE konur, sonra gerekirse geri alinir.
    // "Once onay, sonra isaret" denendi ve CALISMADI: Vuetify'in checkbox'i
    // ic lazyValue tutuyor ve bunu yalnizca inputValue prop'u DEGISTIGINDE
    // senkronluyor (vuetify/lib/mixins/selectable.js). Model zaten false iken
    // tekrar false atamak prop'u degistirmedigi icin watcher tetiklenmiyor ve
    // kutu tiklamayla dondugu halde kaliyordu. Simdiki akista atama gercek bir
    // degisim (true -> false) oldugu icin senkronlaniyor.
    misafirIsmiKontrolDegisti(yeniDeger) {
      if (yeniDeger !== true) {
        return; // isaret kaldiriliyor; onay gerekmez
      }

      // options.message = onay kutusunun etiketi. confirm bileseni bu deger
      // verildiginde "Evet"i yalnizca kutu isaretliyken calistirir.
      this.$refs.confirm
        .open(
          this.$t("Do-Not-Check-Guest-Name"),
          this.$t("Do-Not-Check-Guest-Name-Warning"),
          {
            color: "red",
            width: 560,
            message: this.$t("Do-Not-Check-Guest-Name-Ack"),
          }
        )
        .then((onay) => {
          if (onay !== true) {
            this.misafirIsmiKontrolEdilmesin = false;
          }
        });
    },
    menuClick(index) {
      if (index == 0) {
        this.ParametreOku();
      } else if (index == 1) {
      }
    },
    Aktar(date) {

      let params = {
        tarih: date,
        customerId:this.customerId,
        misafirIsmiKontrolEdilmesin: this.misafirIsmiKontrolEdilmesin
      };

      this.status.loading = true;
      tool.api_post(this, "CoperStream/BizitravelOnlineStream", params).then(
        (response) => {
          this.items = response.body;
          this.status.loading = false;
        },
        (response) => {
          // responseToStatus KULLANILMIYOR: o yalnizca statusText ve
          // body.ExceptionMessage'a bakiyor. Eszamanlilik sinirlayicisi
          // (EszamanliIstekSinirlayici) aciklamayi 429'un DUZ METIN govdesinde
          // gonderiyor; ustelik (HttpStatusCode)429 net462'de tanimli olmadigi
          // icin reason phrase bos geliyor, yani statusText de bos. Sonuc: bos
          // snackbar. HataMesajiCoz once govdeyi okur.
          this.status.loading = false;
          this.status.text = tool.HataMesajiCoz(response, this.$t.bind(this));
          this.status.show = true;
        }
      );
    },
    ayarkaydet() {
      let params = this.BokingAgoraAyar;

      // Mesajlar status uzerinden gosterilir: bu bilesenin data'sinda text1 /
      // snackbar diye alanlar YOK, snackbar baseaktarim'e gecirilen status
      // nesnesine bagli. Eski kod ayrica snackbar'i false yapiyordu, yani
      // hata mesaji hicbir kosulda gorunmuyordu.
      tool
        .api_post(this, "CoperStream/BiziTravelParametreWrite", params)
        .then(
          (response) => {
            if (response.body === true) {
              this.status.text = this.$t("Your-settings-have-been-saved");
              this.dialogayarlar = false;
            } else {
              this.status.text = this.$t("Error-please-try-again");
            }
            this.status.show = true;
          },
          (response) => {
            this.status.text = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.status.show = true;
          }
        );
    },
  },
};

 function ParametreOku() {
    tool.api_post(this, 'CoperStream/BiziTravelParametreRead', {}).then((response) => {

      this.BokingAgoraAyar = response.body

      this.dialogayarlar = true
    }, (response) => {
      // Eskiden text1/snackbar'a yaziliyordu; bu alanlar data'da olmadigi ve
      // snackbar false yapildigi icin hata hic gorunmuyordu.
      this.status.text = tool.HataMesajiCoz(response, this.$t.bind(this))
      this.status.show = true
    })
  }

</script>
